"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalAuthorSearchResponseSchema = exports.ExternalAuthorCandidateSchema = exports.ExternalAuthorSearchRequestSchema = exports.ScopusAuthorSearchRequestSchema = exports.ExternalAuthorQueryStrategySchema = exports.ExternalProfileProviderSchema = void 0;
const zod_1 = require("zod");
// ─── Perfiles de autor externos (Scopus / Web of Science) ───────────
// Contrato compartido web/API para buscar y confirmar manualmente el
// identificador de autor (hoy Scopus; WoS queda como provider futuro).
exports.ExternalProfileProviderSchema = zod_1.z.enum(['scopus', 'wos']);
// Estrategia efectiva con la que el backend resolvió los candidatos.
exports.ExternalAuthorQueryStrategySchema = zod_1.z.enum(['orcid', 'name_affiliation', 'name_only']);
// El correo NO es criterio de búsqueda externa (no forma parte pública del
// perfil de autor); solo viaja como referencia interna/trazabilidad.
exports.ScopusAuthorSearchRequestSchema = zod_1.z
    .object({
    nombre: zod_1.z.string().trim().max(200).optional().nullable(),
    apellidos: zod_1.z.string().trim().max(200).optional().nullable(),
    orcid: zod_1.z.string().trim().max(64).optional().nullable(),
    correo: zod_1.z.string().trim().max(320).optional().nullable(),
    afiliacion: zod_1.z.string().trim().max(300).optional().nullable(),
})
    .refine((d) => Boolean(d.orcid?.trim() || d.apellidos?.trim() || d.nombre?.trim()), { message: 'Indica al menos ORCID o nombre/apellidos para buscar.' });
// El request es agnóstico del proveedor (mismos criterios para Scopus y WoS).
exports.ExternalAuthorSearchRequestSchema = exports.ScopusAuthorSearchRequestSchema;
// Candidato normalizado, independiente del formato crudo de Elsevier/Clarivate.
exports.ExternalAuthorCandidateSchema = zod_1.z.object({
    provider: exports.ExternalProfileProviderSchema,
    externalId: zod_1.z.string(),
    displayName: zod_1.z.string(),
    givenName: zod_1.z.string().nullable().optional(),
    surname: zod_1.z.string().nullable().optional(),
    initials: zod_1.z.string().nullable().optional(),
    orcid: zod_1.z.string().nullable().optional(),
    affiliationName: zod_1.z.string().nullable().optional(),
    affiliationCity: zod_1.z.string().nullable().optional(),
    affiliationCountry: zod_1.z.string().nullable().optional(),
    affiliationId: zod_1.z.string().nullable().optional(),
    documentCount: zod_1.z.number().int().nonnegative().nullable().optional(),
    profileUrl: zod_1.z.string().nullable().optional(),
    // Coincide por ORCID con el buscado (debería ser la persona) → va primero.
    matchedByOrcid: zod_1.z.boolean().optional(),
    // Afiliación institucional (UDA) detectada → segundo criterio de orden.
    affiliationUda: zod_1.z.boolean().optional(),
});
exports.ExternalAuthorSearchResponseSchema = zod_1.z.object({
    provider: exports.ExternalProfileProviderSchema,
    queryStrategy: exports.ExternalAuthorQueryStrategySchema,
    candidates: zod_1.z.array(exports.ExternalAuthorCandidateSchema),
});
